// extracted by mini-css-extract-plugin
export default {"root":"demoEnv_root__Oc3HF"};